import { RiAddFill, RiLoader3Line } from '@remixicon/react'
import { useMutation } from '@tanstack/react-query'
import type { VariantProps } from 'class-variance-authority'
import { useState } from 'react'
import { toast } from 'sonner'

import { bundlesService } from '@/api/bundles/bundles-service'
import type { Detail } from '@/api/orders/orders-types'
import { Button, buttonVariants } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface AddBundleProps {
  detail: Detail
  className?: string
}

export const AddBundle = ({ detail, className }: AddBundleProps) => {
  // const [quantity, setQuantity] = useState(0)

  const [open, setOpen] = useState(false)

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
    >
      <DialogTrigger asChild>
        <Button
          disabled={!!detail?.item?.is_blocked}
          className={cn(className)}
          size='sm'
          variant='outline'
        >
          <RiAddFill />
          <span>Add Bundle</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add bundle</DialogTitle>
        </DialogHeader>

        {/* <NumberInput
          onChange={setQuantity}
          value={quantity}
          minValue={0}
          maxValue={detail.quan}
        /> */}

        {/* <span className='text-xs'>
          <span>Max: </span>
          <span className='text-grey-500'> {detail.quan}</span>
        </span> */}
        <div className='flex w-full items-center gap-2.5 [&_button]:flex-1'>
          <AddBundleButton
            detail={detail}
            onSuccess={() => setOpen(false)}
          />
          <Button
            variant='outline'
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export const AddBundleButton = ({
  onSuccess,
  detail,
  className,
  variant
}: {
  onSuccess?: () => void
  detail: Detail
  className?: string
  variant?: VariantProps<typeof buttonVariants>['variant']
}) => {
  const addBreakMutation = useMutation({
    mutationFn: ({ quantity }: { quantity: number }) =>
      bundlesService.add({
        quantity,
        is_complete: false,
        description: '',
        name: '',
        origin_item: detail.autoid,
        is_printed: false
      }),
    onSuccess: () => {
      toast.success(`Bundle edited successfully`)
      onSuccess?.()
    },
    meta: {
      // `skids`: for boxed products the backend creates or drops a Box unit with the bundle
      invalidatesQuery: ['orders', 'items', 'order', 'timeline-orders', 'skids'],
      successMessage: 'Bundle edited successfully'
    }
  })
  return (
    <Button
      variant={variant}
      className={cn('w-40', className)}
      onClick={() => {
        if (detail?.item?.is_blocked) return
        addBreakMutation.mutate({ quantity: 1 })
      }}
      disabled={addBreakMutation.isPending || !!detail?.item?.is_blocked}
    >
      {addBreakMutation.isPending ? <RiLoader3Line className='animate-spin' /> : <span>Add bundle</span>}
    </Button>
  )
}
